/** Owns only investigation read requests. A generation fence prevents a late
 * token/finish callback from reviving or clearing a newer request after cancel.
 */
export class InvestigationReadScope {
  private disposed = false
  private paused = false
  private current: { id: symbol; cancel?: () => void } | null = null
  get closed() { return this.disposed }

  request() {
    if (this.disposed || this.paused || this.current) return null
    const request = { id: Symbol(), cancel: undefined as (() => void) | undefined }
    this.current = request
    const valid = () => !this.disposed && !this.paused && this.current?.id === request.id
    return {
      onBefore: valid,
      onCancelToken: ({ cancel }: { cancel: () => void }) => {
        if (valid()) request.cancel = cancel
        else cancel()
      },
      onFinish: () => { if (this.current?.id === request.id) this.current = null },
      acceptsResponse: valid,
    }
  }

  pause() {
    this.paused = true
    const request = this.current
    this.current = null
    request?.cancel?.()
  }

  resume() { if (!this.disposed) this.paused = false }
  dispose() { this.disposed = true; this.pause() }
}
